import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { fetchGroup } from 'actions/streams';
import _ from 'lodash';
import cx from "classnames";

import {
    OverlayTrigger, Tooltip,
} from "react-bootstrap";
import { useHistory, useLocation, useParams } from 'react-router-dom';

import FileService from 'services/file.service';

import styles from './groups.module.scss';
import defaultAsset from 'images/default_asset.jpg';
import GenerateLink from 'components/generateLink';
import LockIcon from 'components/lockIcon';
import { deselectAsset, selectAsset } from 'actions/selection';
import { trackAdoptionMetricsForAssetDetailViewedEvent } from 'actions/adoption';

export default function GroupsView(props) {
    const webAppUrl = process.env.REACT_APP_WEBAPP_URL;

    const history = useHistory();
    const params = useParams();
    const dispatch = useDispatch();

    const url = window.location.search;
    const matchResult = url && url.match(/group\/([\w\d]+)/);
    const groupId = matchResult ? matchResult[1] : null;

    const loading = useSelector(state => _.get(state, `streams.group.${params.id}.loading`, false));
    const groupData = useSelector(state => _.get(state, `streams.group.${params.id}.item`));
    const assets = useSelector(state => _.get(state, `application.assets`));

    const [generateLink, setGenerateLink] = useState(false);
    const [selectedAsset, setSelectedAsset] = useState();
    const [selectedAssets, setSelectedAssets] = useState(assets);
    const [source, setSource] = useState(groupId);

    const children = _.get(groupData, "children", [])

    useEffect(() => {
        dispatch(fetchGroup(params.id))
        setSource(groupId);
    }, [params.id])

    const handleSelectAsset = (selectedAsset) => {

        if(selectedAssets.includes(selectedAsset)){
          const filteredAssets = selectedAssets.filter(asset => asset.id != selectedAsset.id);
          setSelectedAssets(filteredAssets);
          dispatch(deselectAsset(selectedAsset));
        }else{
          setSelectedAssets([...selectedAssets, selectedAsset]);
          const allAssets = [...selectedAssets, selectedAsset];
          allAssets.map(asset => dispatch(selectAsset(asset)));
        }
      }

    const handleGenerateLink = (asset) => {
        if (asset.settings && !asset.settings.share) {
            return;
        }
        if(props.attachAssets){
            setSelectedAsset(asset);
            handleSelectAsset(asset);

        }else{
            setSelectedAsset(asset);
            setGenerateLink(true);
        }
    }

    const handleAttachItems = () => {
        history.push("/attachAssets");
    }

    const isSelected = (asset) => {
        return assets.map(item => item.id).includes(asset.id);
    }

    const handleBackClicked = () => {
        if(source){
        const newUrl = props.attachAssets ? `/paperflite-content-library/group/${source}` : `/content-library/group/${source}`;
        history.push(newUrl);
        } else if(source == null){
            props.attachAssets ? history.push("/paperflite-content-library") : history.push("/content-library");
      }
    }

    return (
        <div className={styles.groupContainer}>
            <p className={styles.headerContainer}>
            <span className={styles.backButton} onClick={() => handleBackClicked()}>
            <i className="paperflite-left-arrow"/>
            <span className={styles.back}>
            BACK
            </span>
            </span>
            </p>
            <div className={styles.content}>
                {!loading && <p className={styles.groupName}>{_.get(groupData, "name")}</p>}

                {loading && <p className={styles.loadingGroup}> Loading Group....</p>}

                <div className={styles.childrenContainer}>
                {!loading && <div className={styles.entityChildren}>

                    {children.filter(item => item.entityType === 'group').map(item => {
                        return <GroupNode key={item.id} group={item} attachAssets={props.attachAssets} source={params.id}/>
                    })}

                    {children.filter(item => item.entityType === 'asset').map(item => {
                        return <AssetNode handleGenerateLink={handleGenerateLink} key={item.id} asset={item} isSelected={isSelected} webAppUrl={webAppUrl}/>
                    })}

                    {_.size(children) === 0 && !loading && <p className={styles.noAssets}>No assets</p>}

                    {selectedAsset && <GenerateLink entity={selectedAsset} type="asset" show={generateLink} setShow={setGenerateLink} />}

                </div>}
                </div>

                {_.size(assets) > 0 &&
                <div className={styles.selectedItems} onClick={() => handleAttachItems()}>
                        <span className={styles.selectedAssetsCount}> SELECTED ASSETS ({_.size(assets)}) </span>
                </div>
                }
            </div>
        </div>
    )
}

function GroupNode({ key, group, attachAssets, source}) {
    const history = useHistory();

    const handleRedirect = () => {
        const newUrl = attachAssets ? `/paperflite-content-library/group/${group.id}?source=group/${source}` : `/content-library/group/${group.id}?source=group/${source}`;
        history.push(newUrl)
    }

    return (
        <div className={styles.group} onClick={handleRedirect}>
            <span className={styles.groupIcon}>
                <div className={styles.layer}>&nbsp;</div>
                <div className={styles.groupThumbnail}>
                    <img
                        alt="group thumbnail"
                        src={_.get(group, "icon.thumbnail") || defaultAsset} />
                </div>
                <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip className={styles.toolTip} id="tooltip-name">{group.name}</Tooltip>}
                >
                    <div className={styles.name}>
                        {group.name}
                    </div>
                </OverlayTrigger>
            </span>
        </div>
    );
}

function AssetNode({ asset, handleGenerateLink, isSelected, webAppUrl }) {

    const dispatch = useDispatch();

    return (
        <div className={cx(styles.asset)} key={asset.id}>
            <span className={styles.assetIcon}  
            >
                {asset.settings && !asset.settings.share && <LockIcon />}
                <img
                    alt="asset thumbnail"
                    src={_.get(asset, "icon.thumbnail") || defaultAsset}
                    className={cx({
                        [styles.selectedAsset] : isSelected(asset)
                    })}
                    onClick={() => handleGenerateLink(asset)}
                    />
                {!_.isEmpty(FileService.fileType(asset.metadata)) &&
                    <p className={cx(styles.fileType, {
                    })}>{FileService.fileType(asset.metadata)}</p>
                }
           
            </span>

           {( <OverlayTrigger
                placement="top"
                overlay={<Tooltip className={styles.toolTip} id="tooltip-name">{asset.name}</Tooltip>}
            >
                <div className={styles.assetDetails}>
                <div className={styles.name}>
                {asset.name}
                </div>
                <a href={`${webAppUrl}/assets/${asset.id}?source=chrome_extension`} target="_blank" 
                onClick={() => dispatch(trackAdoptionMetricsForAssetDetailViewedEvent("Asset Detail Viewed", "Content Library", FileService.fileType(_.get(asset, "metadata"))))}>
                <i className={cx(styles.previewIcon, "paperflite-left-arrow")}></i>
                </a>
                </div>
            </OverlayTrigger>)}
            
        </div>
    );
}